var loadNews = ()=>{
    const articleList = document.querySelector(".js-works-list");
    const template = document.getElementById("article-item");
    
    fetch('https://kk-takushin.sakura.ne.jp/contents.php?table=contents&p=children=1%26id=3%26count=100')
    .then((response) => {
        if (!response.ok) {
            throw new Error();
        }
        return response.json();
    })
    .then((res) => {
       
        res.data[0].children.content_details.filter(elm => elm.value.view_flg ).forEach(element => {
            const clone = template.content.cloneNode(true);
            const h3 = clone.querySelector('.works-item__content-title');
            h3.innerHTML = element.value.detail;
            articleList.appendChild(clone);
        });
    })
    .catch((reason) => {
        // エラー
    });
    }
    window.addEventListener("load", (event) => {
        loadNews();
    }, false);